<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path d="M3 13h14.17l-3.585 3.585L15 18l6-6-6-6-1.415 1.415L17.17 11H3z" />
  </svg>
</template>
